import React  from "react";
import { useParams } from 'react-router-dom';
import ModuleForm from "./components/ModuleForm";

const ViewModule = () => {
	const { moduleId } = useParams();
	console.log(moduleId);
    
	return (
	    <div>
	    	<div className="mt-5 grid h-full grid-cols-1 gap-4">
	      		<ModuleForm recordId={moduleId} mode="view"/>
	      </div>
	    </div>
    );
};

export default ViewModule;